











































































import { Component, Prop, Vue } from 'vue-property-decorator';

import EventCategoryTag from '~/components/partials/EventCategoryTag.vue';
import RespectCard from '~/components/cards/RespectCard.vue';
import XSolid from '~/components/icons/XSolid.vue';
import { objectIsEmpty } from '~/utils/common.js';
import LabelsInfos from "~/components/partials/LabelsInfos.vue";

@Component({
  components: { LabelsInfos, EventCategoryTag, RespectCard, XSolid },
})
export default class LocalisationDestinationCard extends Vue {
  @Prop(Object) destination: Types.DestinationItem;
  @Prop(Boolean) isInLocalisationContext: false;
  @Prop(Array) allSports: Types.SportItem[];

  /*
    This tricky computed prevents SSR issues when fetching data
    on page load, as this.news can sometimes be null, and sometimes be {}
  */
  get canShow () {
    if (this.isInLocalisationContext && !objectIsEmpty(this.destination)) {
      return true;
    } else if (!this.isInLocalisationContext) {
      return true;
    }
    return false;
  }

  /*
    This computed will populate sports tags to display. If destination contains
    sports that are from the "OTHER" universe, we want to put them at the end
    of the array as they're considered less important than the other ones
  */
  get sports () {
    let sports: Types.SportSummary[] = this.destination.sports.slice(0).sort((a: Types.SportSummary, b: Types.SportSummary) => {
      return a.title.localeCompare(b.title); // Sort sports alphabetically
    });
    const arrayOfParentSports: any = [];
    const arrayOfOthers: Types.SportSummary[] = [];
    sports.forEach((s: Types.SportSummary, i: number) => {
      if (s.universe === 'OTHER') {
        sports.splice(i, 1);

        arrayOfOthers.push(s);
        arrayOfOthers.sort((a, b) => {
          return a.title.localeCompare(b.title);
        });
        sports = sports.concat(arrayOfOthers);
      }
      // if the sport has parent
      if (s.parent_id) {
        // we check if parent is already in sports array
        const alreadyInSports = sports.findIndex(obj => obj.id === s.parent_id);
        if (alreadyInSports === -1) {
          // we check if parent is already in the array we created before arrayOfParentSports
          const alreadyInNewArray = arrayOfParentSports.findIndex((obj: { id: any; }) => obj.id === s.parent_id);
          if (alreadyInNewArray === -1) {
            // if not, we add it to the arrayOfParentsSports from the list of all sports.
            const indexOfParent = this.allSports.findIndex(obj => obj.id === s.parent_id);
            const sportItem = this.allSports[indexOfParent];
            if (!sportItem) {
              return;
            }
            arrayOfParentSports.push({
              'id':sportItem.id,
              'parent_id':sportItem.parent_id,
              'title':sportItem.title,
              'universe':sportItem.universe,
              'icon_name':sportItem.icon_name,
              'updated_at':sportItem.updated_at,
            });
          }
        }
      } else {
        arrayOfParentSports.push(s);
      }
    });
    return [...new Set(arrayOfParentSports)]; // Avoid potential clones in final array
  }

  /* Image fallback if card <img @error> is triggered */
  imageFallback (event: any) {
    event.target.src = "/img/placeholders/destination-placeholder.png";
  }
}
